<template>
  <div class="flex flex-row items-center justify-between mt-2 mb-1">
    <p class="bottom-section-partner-name">Partner <span>{{ organization.name }}</span></p>
    <p v-if="city !== null && state !== null" class="bottom-section-location flex items-center"> 
      <img class="h-4" src="@/images/header/location_on_II.svg" alt="Service area location">
      {{ `${city}, ${state}` }}
    </p>
    <p v-else-if="organization.data['service_area']" class="bottom-section-location flex items-center"> 
      <img class="h-5" src="@/images/header/location_on_II.svg" alt="Service area location">
      {{ organization.data['service_area'] }}
    </p>
  </div>      
</template>

<script>
export default {
  props: {
    organization: {
      required: true,
      type: Object
    },
    city: {
      type: String,
      required: false
    },
    state: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
.bottom-section-partner-name {
  font-size: 10px;
  font-weight: 400;
  line-height: 10px;
  color: #334155 !important;
  font-weight: 400;

  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    letter-spacing: -0.02em;
    font-weight: 500;
  }
}

.bottom-section-location {
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  letter-spacing: -0.02em;
  color: #334155 !important;
}
</style>